var Geometry = require("./../complexGeometry.js");
var THREE = require("three");
const { mergeGeometries } = require("./BufferGeometryUtils.js")

var ObjImport =  require("./objFileImport.js");
var ObjExport =  require("./objFileExport.js");
var MtlImport =  require("./mtlFileImport.js");

/**
*  A simple 3 dimensional coordinate.
*  [More math operations to come soon]
*    TODO: discuss with Jelle whether we should use THREEJS
*       implimentation of Vector3, which already impliments a LOT of math
*       that we will need.  They probably aren't serializable, and probably
*       use references instead of copies, but we can wrap them to fix that?
*/

Geometry.Coord3d = function(x,y,z) {
    this.x = x;
    this.y = y;
    this.z = z;
    if(x === undefined) x = 0;
    if(y === undefined) y = 0;
    if(z === undefined) z = 0;
    this.lengthCache = null;
    this.normCache = null;
};
Geometry.Coord3d.ORIGIN = new Geometry.Coord3d(0, 0, 0);

Geometry.Coord3d.prototype.copy = function() {
    return new Geometry.Coord3d(this.x, this.y, this.z);
};
Geometry.Coord3d.prototype.clone = Geometry.Coord3d.prototype.copy;

Geometry.Coord3d.validator  = function(val) {
    return val instanceof Geometry.Coord3d && !isNaN(val.x) && !isNaN(val.y) && !isNaN(val.z);
};

Geometry.Coord3d.prototype.eq = function(coord, epsilon) {
    if(epsilon === undefined) epsilon = 0;
    return Math.abs(this.x - coord.x) <= epsilon && Math.abs(this.y - coord.y) <= epsilon && Math.abs(this.z - coord.z) <= epsilon;
};

Geometry.Coord3d.prototype.toString = function() {
    if(!this._string) this._string = '('+this.x+','+this.y+',' + this.z + ')';
    return this._string;
};

Geometry.Coord3d.prototype.getX = function() {
    return this.x;
};

Geometry.Coord3d.prototype.getY = function() {
    return this.y;
};

Geometry.Coord3d.prototype.getZ = function() {
    return this.z;
};

Geometry.Coord3d.prototype.taintCache = function() {
    this.lengthCache = null;
    this.normCache = null;
    this._string = null;
};

Geometry.Coord3d.prototype.toThreejs = function(){
    return new THREE.Vector3(this.x, this.y, this.z);
}

Geometry.Coord3d.prototype.fromThreejs = function(threeVec){
    this.x = threeVec.x;
    this.y = threeVec.y;
    this.z = threeVec.z;
    return this;
}


Geometry.Coord3d.prototype.mult = function(val){
    console.assert(val !== undefined);
    return new Geometry.Coord3d(val*this.x,val*this.y, val*this.z);
}

Geometry.Coord3d.prototype.add = function(coord){
    console.assert(coord instanceof Geometry.Coord3d);
    return new Geometry.Coord3d(coord.x + this.x, coord.y +this.y, coord.z +this.z);
}


/**
*   Triangle Mesh
*       NOTE!! currently no internal data representation,
*              this class is just being used as a convenient
*              to / from threejs interface (wrapper for threejs geometry)
*              but eventually we may want our own way to represent this data,
*              [probably whatever is easiest to pass to fusion?]
*/
Geometry.TriangleMesh = function(threeGeom){
    // representation
    if(threeGeom)
        this.asThreejsGeometry = threeGeom;
    else
        this.asThreejsGeometry = null;

    this.radius = null;
    this.centroid = null;
    this.size = null;
}

//////////////// cached properties
Geometry.TriangleMesh.prototype.taintCache = function(){
    this.radius = null;
    this.centroid = null;
    this.size = null;
}

Geometry.TriangleMesh.prototype.copy = function(){
    return new this.constructor(this.asThreejsGeometry.clone());
}

Geometry.TriangleMesh.prototype.clone = Geometry.TriangleMesh.prototype.copy;

Geometry.TriangleMesh.prototype.getRadius = function(){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");

    if(this.radius == null){
        this.asThreejsGeometry.computeBoundingSphere();
        this.radius = this.asThreejsGeometry.boundingSphere.radius;
    }
    return this.radius;
}

Geometry.TriangleMesh.prototype.getSize = function(){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");

    if(this.size == null){
        this.asThreejsGeometry.computeBoundingBox();
        var x = this.asThreejsGeometry.boundingBox.max.x - this.asThreejsGeometry.boundingBox.min.x;
        var y = this.asThreejsGeometry.boundingBox.max.y - this.asThreejsGeometry.boundingBox.min.y;
        var z = this.asThreejsGeometry.boundingBox.max.z - this.asThreejsGeometry.boundingBox.min.z;
        this.size = new Geometry.Coord3d(x, y, z);
    }
    return this.size;
}


Geometry.TriangleMesh.prototype.getCentroid = function(){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");

    if(this.centroid == null){
        this.asThreejsGeometry.computeBoundingBox();
       // geometry.computeBoundingBox();
        var asThreeVec = new THREE.Vector3();
        asThreeVec.addVectors( this.asThreejsGeometry.boundingBox.min, this.asThreejsGeometry.boundingBox.max );
        asThreeVec.multiplyScalar( - 0.5 );
        //this.centroid = (new Geometry.Coord3d()).fromThreejs(this.asThreejsGeometry.center());
        this.centroid = (new Geometry.Coord3d()).fromThreejs(asThreeVec);
    }
    return this.centroid.clone();
}

/////////////////////////// out conversions
Geometry.TriangleMesh.prototype.toObjFile = function(){
    var mat = new THREE.MeshBasicMaterial( {
        color: 0xffffff
    } );
    var mesh = new THREE.Mesh( this.asThreejsGeometry, mat);
    var object = (new THREE.Object3D()).add(mesh);
    var data = (new ObjExport()).parse( object );
    //console.log(file);
    //this.fromThreejsObject3D(obj);
    //return this;
    var filename = "mesh.obj"
    var type = "obj";
    var a = document.createElement("a"),
        file = new Blob([data], {type: type});
    if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    else { // Others
        var url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }
}


Geometry.TriangleMesh.prototype.toThreejsMesh = function(material){
    if(!material){
        material = new THREE.MeshBasicMaterial();
    }
    return new THREE.Mesh(this.getGeometry().clone(), material)
}

Geometry.TriangleMesh.prototype.getBuffer = function(){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");

    return (new THREE.BufferGeometry).fromGeometry(this.asThreejsGeometry);
}

Geometry.TriangleMesh.prototype.getGeometry = function(){
    //console.assert(this.asThreejsGeometry != null, "triangle mesh empty");

    return this.asThreejsGeometry;
}

/////////////////////////// in conversions
Geometry.TriangleMesh.prototype.fromThreejsGeometry = function(threeGeom){
    this.taintCache();
    this.asThreejsGeometry = threeGeom.clone();
    return this;
}

Geometry.TriangleMesh.prototype.fromThreejsBuffer = function(buffer){
    this.taintCache();
    this.asThreejsGeometry = buffer.clone();
    return this;
}

Geometry.TriangleMesh.prototype.fromThreejsObject3D = function(object){
    var self = this;

    this.taintCache();
    this.asThreejsGeometry = null;

    var recursiveMerge = function(obj){
        if(obj instanceof THREE.Mesh) {
            if(self.asThreejsGeometry == null) {
                self.asThreejsGeometry = obj.geometry.clone();
            } else {
                self.mergeThreejsBufferGeometry(obj.geometry);
            }
        } else if(obj instanceof THREE.Object3D){
            for(var i = 0; i < obj.children.length; i++){
                recursiveMerge(obj.children[i]);
            }
        } else if(obj instanceof THREE.Group) {
            for(var i = 0; i < obj.children.length; i++){
                recursiveMerge(obj.children[i]);
            }
        }
    }

    recursiveMerge(object);
    return this;
}

Geometry.TriangleMesh.prototype.fromObjFile = function(fileData){
    var obj = (new ObjImport()).parse( fileData );
    this.fromThreejsObject3D(obj);
    return this;
}


Geometry.TriangleMesh.prototype.getIntersectMesh = function(threshold){
    var nrFaces = this.asThreejsGeometry.getIndex() ? this.asThreejsGeometry.getIndex().count : 0;
    if(nrFaces > threshold){
        this.asThreejsGeometry.computeBoundingBox();
        var box = this.asThreejsGeometry.boundingBox;
        var width = box.max.x - box.min.x;
        var height = box.max.y - box.min.y;
        var depth = box.max.z - box.min.z;
        var threeboxgeom = new THREE.BoxGeometry(width, height, depth);
        threeboxgeom.translate(-this.getCentroid().x, -this.getCentroid().y, -this.getCentroid().z);
        var mesh = new THREE.Mesh(threeboxgeom, new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0
        }));
        mesh.matrixAutoUpdate = false;
        return mesh;
    } else {
        var mesh = new THREE.Mesh(this.asThreejsGeometry, new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0
        }));
        mesh.matrixAutoUpdate = false;
        return mesh;
    }
}

// this function works a bit different than the rest.  Calling it will import
// the obj geometry data into THIS mesh, and also return a threejs group which
// has the texture included
// (this mesh is just a geom and material is lost, but can still know radius and center)
Geometry.TriangleMesh.prototype.getObjWithMaterial = function(objData, mtlData){

    var mtlLoader = new MtlImport();
    var materials = mtlLoader.parse(mtlData);

    materials.preload();

    var objLoader = new ObjImport();
    objLoader.setMaterials( materials );

    var group = objLoader.parse( objData );

    this.fromThreejsObject3D(group.clone());

    return group;
}


Geometry.TriangleMesh.prototype.fromPolygon = function(polygon, height){
    this.taintCache();

    if(polygon instanceof Geometry.MultiPolygon){
        for(var i = 0; i < polygon.polygons.length; i++){
            var mesh = (new this.constructor()).fromPolygon(polygon.polygons[i], height);
            this.mergeMesh(mesh);
        }
        return this;
    }

    if(polygon.length){
        for(var i = 0; i < polygon.length; i++){
            var mesh = (new this.constructor()).fromPolygon(polygon[i], height);
            this.mergeMesh(mesh);
        }
        return this;
    }

    // else ...

    if(!polygon.points || polygon.points.length == 0){
        console.error("empty polygon");
        return this;
    }

    var shape = new THREE.Shape(polygon.points);

    if(polygon instanceof Geometry.ComplexPolygon){
        for(var i = 0; i < polygon.holes.length; i++){
            var hole = new THREE.Path(polygon.holes[i]);
            shape.holes.push(hole);
        }
    }

    if(height == undefined) height = 1;

    var extrudeSettings = {
        steps: 2,
        depth: height,
        bevelEnabled: false
    };

    this.asThreejsGeometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

    return this;
}

Geometry.TriangleMesh.prototype.fromBox = function(sizeX, sizeY, sizeZ){
    this.taintCache();
    var x = -sizeX/2;
    var y = -sizeY/2;
    var shape = new THREE.Shape();
    shape.moveTo( x, y);
    shape.lineTo( x, y + sizeY );
    shape.lineTo( x + sizeX, y + sizeY );
    shape.lineTo( x + sizeX, y );
    shape.lineTo( x, y );

    var extrudeSettings = {
        steps: 2,
        depth: sizeZ,
        bevelEnabled: false
    };

    this.asThreejsGeometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

    return this;
}

Geometry.TriangleMesh.prototype.fromDrilledBoard = function(x, y, width, height, thickness, holes){
    this.taintCache();

    var shape = new THREE.Shape();
    shape.moveTo( x, y);
    shape.lineTo( x, y + height );
    shape.lineTo( x + width, y + height );
    shape.lineTo( x + width, y );
    shape.lineTo( x, y );

    if(holes){
        for(var i = 0; i < holes.length; i++){
            if(!holes[i].points.length) continue;
            var hole = new THREE.Path(holes[i].points);
            shape.holes.push(hole);
        }
    }

    var extrudeSettings = {
        steps: 2,
        depth: thickness,
        bevelEnabled: false
    };

    this.asThreejsGeometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

    return this;
}


/////////////////////////// other methods
Geometry.TriangleMesh.prototype.mergeMesh = function(triangleMesh){
    if(!triangleMesh || triangleMesh.isEmpty()) return;
    console.assert(triangleMesh instanceof Geometry.TriangleMesh, "not merging with correct object type");

    this.taintCache();
    if(!this.asThreejsGeometry){
        this.asThreejsGeometry = triangleMesh.getGeometry();
        return this;

    }

    this.asThreejsGeometry = mergeGeometries([this.asThreejsGeometry, triangleMesh.getGeometry()]);

    return this;
}

Geometry.TriangleMesh.prototype.isEmpty = function(){
    if(!this.asThreejsGeometry) return true;
    else return false;
}

Geometry.TriangleMesh.prototype.mergeThreejsBufferGeometry = function(buffer){
    if(!buffer) return;
    console.assert(buffer instanceof THREE.BufferGeometry, "not merging with correct object type");

    this.taintCache();
    if(!this.asThreejsGeometry){
        this.asThreejsGeometry = buffer.clone();
        return this;
    }
    this.asThreejsGeometry = mergeGeometries([this.asThreejsGeometry, buffer.clone()]);

    return this;
}

Geometry.TriangleMesh.prototype.scale = function(x, y, z){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");
    this.taintCache();

    if(this.asThreejsGeometry) this.asThreejsGeometry.scale(x, y, z);
    return this;
}

Geometry.TriangleMesh.prototype.translate = function(x, y, z){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");
    this.taintCache();

    if(this.asThreejsGeometry) this.asThreejsGeometry.translate(x, y, z);
    return this;
}

/*
Geometry.TriangleMesh.prototype.rotateGlobalY = function(deg){
    var center = this.getCentroid();
    this.taintCache();
    this.asThreejsGeometry.translate( center.x, center.y, center.z);
    this.asThreejsGeometry.rotateOnAxis(new THREE.Vector3(0, 1, 0), deg * Math.PI/180);
    this.asThreejsGeometry.translate( -center.x, -center.y, -center.z);
    return this;
}
*/
Geometry.TriangleMesh.prototype.rotateX = function(deg){
    this.taintCache();
    if(this.asThreejsGeometry) this.asThreejsGeometry.rotateX(deg * Math.PI/180);
    return this;
}
Geometry.TriangleMesh.prototype.rotateY = function(deg){
    this.taintCache();
    if(this.asThreejsGeometry) this.asThreejsGeometry.rotateY(deg * Math.PI/180);
    return this;
}
Geometry.TriangleMesh.prototype.rotateZ = function(deg){
    this.taintCache();
    if(this.asThreejsGeometry) this.asThreejsGeometry.rotateZ(deg * Math.PI/180);
    return this;
}


Geometry.TriangleMesh.prototype.rotateAround2d = function(deg, pos){
    console.assert(this.asThreejsGeometry != null, "triangle mesh empty");
    this.taintCache();
    if(this.asThreejsGeometry){
      this.asThreejsGeometry.translate(-pos.x, -pos.y, 0);
      this.asThreejsGeometry.rotateZ(deg * Math.PI/180);
      this.asThreejsGeometry.translate(pos.x, pos.y, 0);
    }
    return this;

}

Geometry.TriangleMesh.prototype.dispose = function(){
    if(this.asThreejsGeometry) this.asThreejsGeometry.dispose();
}

module.exports = Geometry;
